(() => {
  if (document.scrollingElement) {
    return;
  }

  const checkForAndAssignBody = () => {
    if (!document.body) {
      window.requestAnimationFrame(checkForAndAssignBody);
      return;
    }

    document.scrollingElement = document.body;
  };

  document.scrollingElement = document.documentElement;
})();

